import { LegacyDevice } from 'console/device/device';
import { Capability } from 'console/device/device-capability';
import { GuardTab } from './tab';
import { DefaultTabKey } from 'console/shared/content/tab/types';
export const guard_tab_definition = {
    key: DefaultTabKey.guard_tab,
    title: 'Охрана',
    iconclass: 'ui-icon-tab-guard',
    should_appear_depends_on: ['capabilities', 'z3k_config'],
    should_appear: (_device, _account, r_device) => {
        if (LegacyDevice.has_capability(r_device?.capabilities, Capability.has_z3k_settings))
            if (r_device.z3k_config &&
                ((r_device.z3k_config.guard_zones &&
                    r_device.z3k_config.guard_zones?.length > 0) ||
                    r_device.device_type?.code.includes('C2000')))
                return true;
        return false;
    },
    render: GuardTab,
};
